export interface SourceTablesItemType {
  title: string;
  type: string;
  newTitle?: string;
}

export interface SourceTablesInterface extends SourceTablesItemType {
  items: SourceTablesItemType[];
}

export interface LoadingScriptStateInterface {
  SQLScript: string;
  sourceTables: SourceTablesInterface[];
  pagesScript: PagesScriptInterface[];
  activePageScript: string;
}

export interface PagesScriptInterface {
  page: string;
  script: string;
}

export type TablePreviewTypes = Record<string, string | number | null>;

export type TablePreviewTypesNew = Record<string, { value: string | number | null; error: string | null }>;

export interface TableFieldsPreviewInterface {
  meta: { sourceName: string; sourceType: string; newName: string | null; newType: string | null; isHide: boolean }[];
  data: TablePreviewTypesNew[];
}

export interface InformationTableSourceInterface {
  sourceId: string;
  schemaName?: string;
  tableName: string;
  rowCount: number;
  driverType: string;
}

export interface TableSelectedInterface {
  schema?: string;
  table: string;
  columns: ColumnsTableInterface[];
}

export interface ColumnsTableInterface {
  name: string;
  type?: string;
}

/* Action Types */
export enum LoadingScriptActionsTypes {
  GET_SQL_SCRIPT = 'GET_SQL_SCRIPT',
  RUN_SQL_SCRIPT = 'RUN_SQL_SCRIPT',
  LOADING_TABLES = 'LOADING_TABLES',
  LOADING_PREVIEW_TABLES = 'LOADING_PREVIEW_TABLES',
  CREATE_TABLES_SCRIPT = 'CREATE_TABLES_SCRIPT',
  LOAD_SOURCE_FILE_STATUS = 'LOAD_SOURCE_FILE_STATUS',
  UPLOAD_SQL_SCRIPT = 'UPLOAD_SQL_SCRIPT',
  LOAD_COPY_URL_SCRIPT = 'LOAD_COPY_URL_SCRIPT',
  CLEAR_LOADING_SCRIPT = 'CLEAR_LOADING_SCRIPT',
  CLEAR_SOURCE_TABLES = 'CLEAR_SOURCE_TABLES',
  ADD_NEW_PAGE_SQL_SCRIPT = 'ADD_NEW_PAGE_SQL_SCRIPT',
  DELETE_PAGE_SQL_SCRIPT_BY_ID = 'DELETE_PAGE_SQL_SCRIPT_BY_ID',
  SELECT_PAGE_SQL_SCRIPT_BY_ID = 'SELECT_PAGE_SQL_SCRIPT_BY_ID',
  ON_EDIT_PAGE_SQL_SCRIPT_BY_ID = 'ON_EDIT_PAGE_SQL_SCRIPT_BY_ID',
  ON_EDIT_SCRIPT_ACTIVE_PAGE_SQL_SCRIPT = 'ON_EDIT_SCRIPT_ACTIVE_PAGE_SQL_SCRIPT',
}

/* Payload Interfaces */
export interface FieldsPreviewTablesPayload {
  sourceId: string;
  tableName: string;
  schemaName?: string;
}

export type InformationTableSourcePayload = FieldsPreviewTablesPayload;

export interface CreateTablesScriptActionPayload extends FastBoard.API.ScriptAddTablesDTO {
  projectId: string;
  sourceId: string;
  tables: TableSelectedInterface[];
  type: 'increment' | 'full';
  page: string;
}

export interface UploadSQLScriptPayload {
  projectId: string;
  pages: PagesScriptInterface[];
}
